import React from 'react';
import { Radar } from 'lucide-react';
import { VerboseLog } from './DashboardWidgets';
import NewsAnalysisPanel from '../NewsAnalysisPanel';

const ScanTab = ({ scanLogs, isScanning, sources, token }) => {
  return (
    <div className="space-y-6">
      <div className="bg-black/60 border-2 border-marine-slate/50 p-6">
        <h2 className="font-heading text-marine-cyan text-2xl uppercase tracking-wider mb-4 flex items-center gap-3">
          <Radar className="w-7 h-7" />
          Scan OSINT
          {isScanning && <span className="ml-auto text-marine-green text-lg animate-pulse">● ACTIF</span>}
        </h2>
        <VerboseLog logs={scanLogs} isRunning={isScanning} />
      </div>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
        {sources.slice(0, 8).map(source => (
          <div key={source.id} className={`p-3 border-2 ${source.is_active ? 'border-marine-green/50 bg-marine-green/10' : 'border-marine-slate/30'}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className={`w-3 h-3 rounded-full ${source.is_active ? 'bg-marine-green animate-pulse' : 'bg-marine-slate'}`} />
                <span className="font-mono text-sm text-white">{source.name}</span>
              </div>
              <span className="font-mono text-sm text-marine-amber font-bold">{(source.weight * 100).toFixed(0)}%</span>
            </div>
          </div>
        ))}
      </div>

      {/* News Analysis Panel */}
      <NewsAnalysisPanel token={token} />
    </div>
  );
};

export default ScanTab;
